import styled from '@emotion/styled';
import { css } from '@emotion/react';
import tokens from '@vaa-component-lib/shared.design-tokens/json/variables.json';

import { NoGapSupport } from '../../lib/utils/mixins';

const {
	spacing: {
		size_2px: { height: size_2 },
		size_4px: { height: size_4 },
		size_8px: { height: size_8 },
		size_12px: { height: size_12 },
		size_64px: { height: size_64 }
	},
	color: colours
} = tokens;

export const CriteriaButton = styled.button`
	width: 100%;
	min-height: ${size_64 + size_2}px;
	text-align: left;
	cursor: pointer;
	padding: ${size_12}px;
	background: ${colours.light.background_primary};
	border: 1px solid ${colours.light.border_decorative};
	border-radius: ${size_8}px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: ${colours.light.text_primary};

	&.has-error {
		border: 1px solid ${colours.light.red_60};
	}

	&[disabled] {
		background: ${colours.light.background_secondary};
		border-color: ${colours.light.border_decorative};
		color: ${colours.light.text_secondary};
		cursor: default;
	}
`;

export const CriteriaInner = styled.span`
	display: flex;
	gap: ${size_8}px;
	align-items: center;
	justify-content: flex-start;

	.icon-component {
		${NoGapSupport(
			() => css`
				margin: 0 ${size_8}px 0 0;
			`
		)}
	}
`;

export const CriteriaLabels = styled.span`
	display: flex;
	flex-direction: column;
	gap: ${size_4}px;
	justify-content: flex-start;
	${NoGapSupport(
		() => css`
			span {
				&:nth-of-type(2) {
					margin: ${size_4}px 0 0;
				}
			}
		`
	)}
`;

export const CriteriaErrorLabel = styled.span`
	color: ${colours.light.text_error};
`;
